import React from 'react'
import { compose, graphql } from 'react-apollo'
import styled from 'styled-components'
import loSto from '../config/loSto'
import {
  LO_STO,
  SUBMIT_PREFERENCE,
  setSignOffModal,
  RESPONSIVE,
  FETCH_POLICY,
  isProblemSectionNeedOpsProcessing
} from '../lib'
import { Loading, Constants } from '@sukiai/components'
import checkGreen from '../lib/assets/icons/check-green.svg'
import signNote from '../lib/assets/icons/sign-note-white.svg'
import client from '../apollo'
import { SET_MODAL_DISMISS } from '../apollo/actions'
import { GetEnhancedReviewByOrganizationId } from '@sukiai/gql/app'
import { isCerner, isAthena, isSukiOnly, isEpic, isRedRover, isSubmitNotesAsPreliminary } from '../lib/util'

const Terms = styled.div`
  padding: 1rem;
  text-align: ${(props) => (props.justify ? 'left' : 'center')};
  font-size: 15px;
  margin-top: 10px;
  color: #212121;
`

const TermsButton = styled.button`
  border: none;
  background: transparent;
  font-size: 15px;
  span {
    color: #212121;
    border-bottom: 1px solid;
    cursor: pointer;
  }
`

const TermsCaption = () => {
  const [showTerms, setShowTerms] = React.useState(false)
  const termsString = 'By e-signing, you acknowledge and agree that you are solely responsible for the accuracy and completeness of your notes and meeting any third-party payor requirements.'
  const disclaimerString = 'By e-signing, you accept Suki AI’s'

  if (isAthena() && !isSukiOnly()) {
    return null
  }

  if (isRedRover() || (isEpic() && isSubmitNotesAsPreliminary())) {
    return null
  }

  if (showTerms) {
    return <Terms justify>{termsString}</Terms>
  }

  return (
    <Terms>
      {disclaimerString}
      <TermsButton
        className='terms-btn'
        aria-haspopup='true'
        aria-expanded={showTerms}
        onClick={() => setShowTerms(true)}
      >
        <span>terms</span>.
      </TermsButton>
    </Terms>
  )
}

const SignNoteButton = styled.button`
  border: none;
  margin: 0 auto;
  font-weight: normal;
  border-radius: 25px;
  padding: .333rem;
  min-width: 298px;
  min-height: 58px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(46,95,98);
  color: #fff;
  cursor: pointer;
  font-size: 20px;
`

const EnhancedReviewButton = styled.button`
  border: 1px solid rgb(46,95,98);
  margin: 0 auto;
  border-radius: 25px;
  padding: .333rem;
  min-width: 298px;
  min-height: 58px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 20px;
  background-color: rgb(255,255,255);
`

const styles = {
  modalContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: RESPONSIVE.MODAL_MED_WIDTH,
    width: RESPONSIVE.MODAL_FULL_WIDTH,
    boxSizing: 'border-box',
    minWidth: '300px',
    backgroundColor: 'white',
    boxShadow: '0px 0px 10px rgba(1,1,1,0.2)',
    padding: '30px',
    zIndex: '10000',
    fontSize: '15pt',
    borderRadius: '6px'
  },
  mainContent: {
    width: '100%'
  },
  radioOption: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    fontSize: '15pt'
  },
  icon: {
    width: '24px',
    height: '24px',
    position: 'absolute',
    marginLeft: '-91px',
    marginTop: '-11px'
  },
  selectButton: {
    display: 'flex',
    justifyContent: 'left',
    alignItems: 'center',
    textAlign: 'center',
    color: '#2E5F62',
    width: '99%',
    height: '46px',
    borderRadius: '8px',
    border: '1px solid #2E5F62',
    marginLeft: 'auto',
    paddingLeft: '20px',
    fontSize: '15pt',
    cursor: 'pointer'
  },
  heading: {
    marginBottom: '34px',
    fontWeight: '600',
    fontSize: '15pt'
  },
  divider: {
    width: '100%',
    height: '40px',
    textAlign: 'center',
    paddingTop: '10px'
  },
  loading: {
    margin: '40px 0px',
    position: 'relative'
  }
}

class NewSubmitModal extends React.Component {
  state = {
    currentUser: loSto.get(LO_STO.CURRENT_USER),
    isBypassSelected: loSto.get(LO_STO.SUBMIT_PREFERENCE) === SUBMIT_PREFERENCE.BYPASS_QA,
    hasDictation: isProblemSectionNeedOpsProcessing()
  }

  isSukiOnlyOrCernerOrEpic = () => {
    return isSukiOnly() || (isCerner() && !isRedRover()) || (isEpic() && !isSubmitNotesAsPreliminary())
  }

  async componentWillReceiveProps (nextProps) {
    const shouldDismissModal = nextProps.shouldDismiss && this.props.open
    if (shouldDismissModal) {
      nextProps.removeModal()
    }
  }

  handleOption = option => {
    const { handleSubmitNoteBypassQa, submitNote } = this.props

    if (option === SUBMIT_PREFERENCE.BYPASS_QA) {
      if (this.isSukiOnlyOrCernerOrEpic()) {
        // Non-EMR users
        client.mutate({ mutation: SET_MODAL_DISMISS })
        loSto.set(LO_STO.SHOULD_BYPASS_QA, true)
        setSignOffModal()
      } else {
        loSto.set(LO_STO.SUBMIT_PREFERENCE, SUBMIT_PREFERENCE.BYPASS_QA)
        handleSubmitNoteBypassQa()
      }
    } else {
      loSto.set(LO_STO.SUBMIT_PREFERENCE, SUBMIT_PREFERENCE.WITH_QA)
      submitNote(false, false, false)
    }

    const { TOAST } = Constants
  }

  getModalTitle = () => {
    const { isBypassSelected } = this.state

    let title = isBypassSelected ? 'Send to EMR Now' : 'Have Suki Process It First'
    title = this.isSukiOnlyOrCernerOrEpic() ? 'Sign note' : title

    return title
  }

  getButtonImage = () => {
    if (this.isSukiOnlyOrCernerOrEpic()) return signNote
    else return checkGreen
  }

  getButtonText = () => {
    if (this.isSukiOnlyOrCernerOrEpic()) return 'Sign note'
    else return 'Send now'
  }

  getButtonDataCy = () => {
    if (this.isSukiOnlyOrCernerOrEpic()) return 'sign-note-btn'
    else return 'send-now-btn'
  }

  render () {
    const { heading, loading } = this.props

    return (
      <div style={styles.modalContainer} onClick={e => e.stopPropagation()} data-cy={this.isSukiOnlyOrCernerOrEpic() ? 'sign-off-note-modal' : `${heading}-modal`}>
        <div style={styles.heading}>
          {this.isSukiOnlyOrCernerOrEpic() ? 'Sign note now?' : heading}
        </div>
        {loading
          ? <Loading style={styles.loading} />
          : (
            <div style={styles.mainContent}>
              <div style={styles.radioOption}>
                <SignNoteButton
                  onClick={() => this.handleOption(SUBMIT_PREFERENCE.BYPASS_QA)}
                  data-cy={this.getButtonDataCy()}
                >
                  <div>
                    <img src={this.getButtonImage()} style={styles.icon} alt='Sign or Send' />
                  </div>
                  <div>
                    {this.getButtonText()}
                  </div>
                </SignNoteButton>
              </div>
              {this.props.organizationEnhancedReview !== 'OFF' && this.state.currentUser.enhancedReview !== 'OFF' && this.state.hasDictation && (
                <>
                  <div style={styles.divider}>or</div>
                  <div style={styles.radioOption}>
                    <EnhancedReviewButton
                      onClick={() => this.handleOption(SUBMIT_PREFERENCE.WITH_QA)}
                      data-cy='suki-process-first-btn'
                    >
                      <div>
                        <span>Enhanced review</span>
                      </div>
                    </EnhancedReviewButton>
                  </div>
                </>
              )}
              <TermsCaption />
            </div>
          )}
      </div>
    )
  }
}

const mapOrganizationIdToProps = ({ data }) => {
  return {
    organizationId: data.organizations.results[0].id,
    organizationEnhancedReview: data.organizations.results[0].enhancedReview
  }
}

export default compose(
  graphql(GetEnhancedReviewByOrganizationId, {
    options: () => ({
      variables: {
        id: loSto.get(LO_STO.ORGANIZATION_ID)
      }
    }),
    fetchPolicy: FETCH_POLICY.NETWORK_ONLY,
    props: mapOrganizationIdToProps
  })
)(NewSubmitModal)
